'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

const PageClassIdentifier = () => {
  const pathname = usePathname();

  useEffect(() => {
    const getClassForPage = () => {
      switch (true) {
        case pathname === '/':
          return 'homepage';
        case pathname.startsWith('/categories'):
        case pathname.startsWith('/search'):
          return 'plp';
        case pathname.startsWith('/products'):
          return 'pdp';
        case pathname.startsWith('/blog'):
          return 'blog';
        case pathname.startsWith('/cart'):
          return 'cart';
        case pathname.startsWith('/checkout'):
          return 'checkout';
        default:
          return 'content';
      }
    };

    const pageClass = getClassForPage();
    if (pageClass) {
      document.body.classList.add(pageClass);
    }

    return () => {
      if (pageClass) {
        document.body.classList.remove(pageClass);
      }
    };
  }, [pathname]);

  return <></>;
};

export default PageClassIdentifier;
